import React from 'react';
import { Link } from 'react-router-dom';
import {
  Button,
  Checkbox,
  Col,
  Form,
  Input,
  Row,
  Select,
  Tooltip,
} from 'antd';

import {
  ThemeColors,
} from '@constants/Theme';

const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute('content');

class SignUpForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      confirmDirty: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeText = this.onChangeText.bind(this);
    this.handleConfirmBlur = this.handleConfirmBlur.bind(this);
  }

  handleSubmit(values) {
    this.setState({ isLoading: true });
    // Form validated successfully via onFinish — submit the HTML form
    const formEl = document.querySelector('form[action="/users"]');
    if (formEl) formEl.submit();
  }

  onChangeText(key, e) {
    this.setState({
      [key]: e.target.value,
    })
  }

  handleConfirmBlur(e) {
    const value = e.target.value;
    this.setState({ confirmDirty: this.state.confirmDirty || !!value });
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };

    return (
      <Form form={this.props.form} onFinish={this.handleSubmit} action="/users" method="POST">
        <input type="hidden" name="authenticity_token" value={ csrfToken } />
        <input type="hidden" name="user[email]" value={ this.state.email } />
        <input type="hidden" name="user[password]" value={ this.state.password } />
        <input type="hidden" name="user[password_confirmation]" value={ this.state.password_confirmation } />
        <input type="hidden" name="user[first_name]" value={ this.state.first_name } />
        <input type="hidden" name="user[last_name]" value={ this.state.last_name } />
        <input type="hidden" name="user[phone_number]" value={ this.state.phone_number } />

        <Form.Item
          hasFeedback
          {...formItemLayout}
          label="E-mail"
          name="email"
          rules={[{ required: true, message: 'Please input your email!' }]}
        >
          <Input
            size="large"
            onChange={ (e) => this.onChangeText('email', e) }
          />
        </Form.Item>
        <Form.Item
          hasFeedback
          {...formItemLayout}
          label="Password"
          name="password"
          rules={[{ required: true, message: 'Please input your password!' }]}
        >
          <Input
            type="password"
            onChange={ (e) => this.onChangeText('password', e) }
          />
        </Form.Item>
        <Form.Item
          hasFeedback
          {...formItemLayout}
          label="Confirm Password"
          name="password_confirmation"
          rules={[
            { required: true, message: 'Please confirm your password!' },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Two passwords do not match!'));
              },
            }),
          ]}
        >
          <Input
            type="password"
            onBlur={this.handleConfirmBlur}
            onChange={ (e) => this.onChangeText('password_confirmation', e) }
          />
        </Form.Item>
        <Form.Item
          hasFeedback
          {...formItemLayout}
          label="First name"
          name="first_name"
          rules={[{ required: true, message: 'Please input your first name.' }]}
        >
          <Input onChange={ (e) => this.onChangeText('first_name', e) } />
        </Form.Item>
        <Form.Item
          hasFeedback
          {...formItemLayout}
          label="Last name"
          name="last_name"
          rules={[{ required: true, message: 'Please input your last name.' }]}
        >
          <Input onChange={ (e) => this.onChangeText('last_name', e) } />
        </Form.Item>
        <Form.Item
          hasFeedback
          {...formItemLayout}
          label="Phone Number"
          name="phone_number"
          rules={[{ required: true, message: 'Please input your phone number!' }]}
        >
          <Input onChange={ (e) => this.onChangeText('phone_number', e) } />
        </Form.Item>
        <Form.Item
          {...tailFormItemLayout}
          name="agreement"
          valuePropName="checked"
          rules={[{
            validator: (_, value) =>
              value ? Promise.resolve() : Promise.reject(new Error('Please agree to the agreement')),
          }]}
        >
          <Checkbox>I have read the <a href="https://www.mypropty.com/privacy-policy">agreement</a></Checkbox>
        </Form.Item>
        <Form.Item {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit" loading={ this.state.isLoading }>Register</Button>
        </Form.Item>
        <Row type="flex" justify="space-between">
          <Link to="/login">Login</Link>
          <Link to="/forgot_password">Forgot password</Link>
        </Row>
      </Form>
    );
  }
}

const WrappedSignUpForm = (props) => {
  const [form] = Form.useForm();
  return <SignUpForm {...props} form={form} />;
};

export default class SignUpScreen extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Row
        type="flex" justify="center" align="middle"
        style={{ height: '100%', marginTop: 30, marginBottom: 30 }}
      >
        <Col
          xs={{ span: 24, offset: 0 }}
          sm={{ span: 20, offset: 0 }}
          md={{ span: 16, offset: 0 }}
          lg={{ span: 12, offset: 0 }}
          style={{
            backgroundColor: 'white',
            borderColor: ThemeColors.darkBlue,
            borderStyle: 'solid',
            borderWidth: 1,
            padding: 30,
          }}
        >
          <h2>Sign up</h2>
          <WrappedSignUpForm />
        </Col>
      </Row>
    )
  }
}
